import BpkMobileScrollContainer from '@skyscanner/backpack-web/bpk-component-mobile-scroll-container';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import FilterGroups from './FilterGroups';
import FilterWithTagsGroup from './FilterWithTagsGroup';
import SortByGroup from './SortByGroup';

import type { OnApplyFilter } from '@hotels-hotel-detail/data-access/types/hotel-reviews';
import type { MiniEventTracker } from '@shared/types/frontend/mini-event-tracker';
import type { FilterGroup } from '@shared/types/frontend/ubff/hotel-reviews';

import STYLES from './FiltersAndSortSelectors.module.scss';

import { useHotelReviewsContext } from '@hotels-hotel-detail/data-access/hooks/useHotelReviewsContext';
import { buildUBFFReviewFilterClicked } from '@hotels-hotel-detail/utils/mini-events/hotels-action';
import { getFilterGroupByType } from '@hotels-hotel-detail/utils/review-service';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import { withMiniEventTracker } from '@shared/ui/contexts/mini-events';
import { ACTION_TYPE } from '@shared/utils-frontend/mini-events/constants';

const cls = cssModules(STYLES);

const FiltersAndSortSelectors = ({
  miniEventTracker,
}: {
  miniEventTracker: MiniEventTracker;
}) => {
  const {
    applyFilter,
    data: reviewResult,
    isLoading,
  } = useHotelReviewsContext();
  const { filterGroup: filterGroups, sorts } = reviewResult || {};

  const filterMainGroups = getFilterGroupByType({
    filterGroups,
    tagType: false,
  });
  const filtersWithTagGroup = getFilterGroupByType({
    filterGroups,
    tagType: true,
  });

  const applyReviewFilter: OnApplyFilter = ({ type, value }) => {
    applyFilter({ type, value });
    miniEventTracker.trackHotelsAction(
      ACTION_TYPE.DETAILS_REVIEW_FILTER_CLICKED,
      buildUBFFReviewFilterClicked({ type, value }),
    );
  };

  return (
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isMobile: boolean) => {
        const disabled = isMobile ? isLoading : false;
        return (
          <div className={cls('FiltersAndSortSelectors')}>
            <BpkMobileScrollContainer>
              <div className={cls('FiltersAndSortSelectors__wrapper')}>
                <div className={cls('FiltersAndSortSelectors__rowContainer')}>
                  {sorts && sorts.length > 0 && (
                    <SortByGroup sorts={sorts} disabled={disabled} />
                  )}
                  {filterMainGroups.length > 0 && (
                    <FilterGroups
                      applyFilter={applyReviewFilter}
                      groups={filterMainGroups as FilterGroup[]}
                      disabled={disabled}
                    />
                  )}
                </div>
              </div>
            </BpkMobileScrollContainer>
            {filtersWithTagGroup.length > 0 && (
              <FilterWithTagsGroup
                isMobile={isMobile}
                disabled={disabled}
                applyFilter={applyReviewFilter}
                tagGroup={filtersWithTagGroup[0] as FilterGroup}
              />
            )}
          </div>
        );
      }}
    </BpkBreakpoint>
  );
};

export default withMiniEventTracker(FiltersAndSortSelectors);
